const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;

export function teachingWeekForDate(referenceDate, semesterStart) {
  const dateMs = new Date(`${referenceDate}T00:00:00+08:00`).getTime();
  const startMs = new Date(`${semesterStart}T00:00:00+08:00`).getTime();
  return Math.max(1, Math.floor((dateMs - startMs) / MS_PER_WEEK) + 1);
}

export function courseRunsThisWeek(weeksText, week) {
  const ranges = Array.from(weeksText.matchAll(/(\d+)[–-](\d+)/g)).map(
    (match) => [Number(match[1]), Number(match[2])],
  );
  const listed = weeksText.match(/(?:^|[^\d])(\d+(?:、\d+)+)周/)?.[1];
  const start = Number(weeksText.match(/第(\d+)周起/)?.[1] || 1);
  const scheduled = ranges.length
    ? ranges.some(([from, to]) => week >= from && week <= to)
    : listed
      ? listed.split("、").map(Number).includes(week)
      : week >= start && week <= 18;
  if (!scheduled) return false;
  if (/单周/.test(weeksText) && week % 2 === 0) return false;
  if (/双周/.test(weeksText) && week % 2 !== 0) return false;
  const excluded = weeksText.match(/除(\d+(?:、\d+)*)周/)?.[1];
  return !excluded || !excluded.split("、").map(Number).includes(week);
}
